import { ServicosApiResponse } from "../@types/servicos";
import { Token } from "../utils/localStorage.util";
import axios, {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";
import config from "../config.js";

const apiEmpresas = axios.create({
  baseURL: config.REACT_APP_HOST_API_EMPRESAS,
});

apiEmpresas.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    const token = Token.getToken();
    if (token) {
      config.headers.Authorization = token;
    }

    if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error: AxiosError) => {
    Promise.reject(error);
  }
);

apiEmpresas.interceptors.response.use(
  (response: AxiosResponse) => {
    return response.data;
  },

  async function (error: AxiosError) {
    if (error?.code === "ERR_NETWORK") {
      return;
    }

    return Promise.reject(error);
  }
);


// ----------------------------------------------------------------------------------------------------

// API Empresas - Busca completa
export function buscarTodosGruposEconomicos(): Promise<ServicosApiResponse> {
  return apiEmpresas.get(`/grupos-economicos/`);
}

// API Empresas - Busca
export function buscarGruposPorTexto(
  textoBusca: string
): Promise<ServicosApiResponse> {
  return apiEmpresas.get(
    `/grupos-economicos/buscar-por-campos?textoDeBusca=${encodeURIComponent(textoBusca)}`
  );
}

//API Empresas - inserir
export function cadastraGrupoEconomico(
  body: any,
  headers: any
): Promise<ServicosApiResponse> {
  return apiEmpresas.post(`/grupos-economicos/`, body, headers);
}

//API Empresas - atualizar
export function atualizarGrupoEconomico(
  id_grupo_economico: number,
  body: any,
  headers: any
): Promise<ServicosApiResponse> {
  return apiEmpresas.put(
    `/grupos-economicos/${id_grupo_economico}`,
    body,
    headers
  );
}

//API Empresas - deletar
export function deletarGrupoEconomico(
  id_grupo_economico: number,
  headers: any
): Promise<ServicosApiResponse> {
  return apiEmpresas.delete(
    `/grupos-economicos/${id_grupo_economico}`,
    headers
  );
}

// ----------------------------------------------------------------------------------------------------

type BuscarTodosClientesParams = {
  limit?: number;
  offset?: number;
  q?: string;
  ativo?: boolean;
};

// API Clientes - Busca completa
export function buscarTodosClientes(
  params?: BuscarTodosClientesParams
): Promise<ServicosApiResponse> {
  return apiEmpresas.get(`/empresas/`, { params });
}

// API Clientes - Busca
export function buscarClientesPorTexto(
  textoBusca: string
): Promise<ServicosApiResponse> {
  return apiEmpresas.get(
    `/empresas/buscar-por-campos?textoDeBusca=${encodeURIComponent(textoBusca)}`
  );
}

//API Clientes - inserir
export function cadastraClientes(
  body: any,
  certFile: File
): Promise<ServicosApiResponse> {
  return apiEmpresas.postForm(`/empresas/`, {
    'cadastro': body,
    'certFile': certFile
  });
}

//API Clientes - atualizar
export function atualizarClientes(
  id_clientes: number,
  body: any,
  certFile: File,
): Promise<ServicosApiResponse> {
  return apiEmpresas.putForm(`/empresas/${id_clientes}`, {
    'alteracao': body,
    'certFile': certFile
  });
}

//API Clientes - deletar
export function deletarCliente(
  id_cliente: number
): Promise<ServicosApiResponse> {
  return apiEmpresas.delete(`/empresas/${id_cliente}`);
}

export function buscarClientesPorID(
  id: number
): Promise<ServicosApiResponse> {
  return apiEmpresas.get(
    `/empresas/${id}`
  );
}


export default apiEmpresas;